
import { Button } from "@/components/ui/button";
import { ArrowLeft, Heart } from "lucide-react";
import { useLocalFavorites } from "@/hooks/useLocalFavorites";
import { useLocalFavoritesData } from "@/hooks/useLocalFavoritesData";
import { VacationCard } from "./VacationCard";
import { VacationCardSkeleton } from "./VacationCardSkeleton";

interface FavoritesProps {
  onBack: () => void;
}

export const Favorites = ({ onBack }: FavoritesProps) => {
  const { favorites, toggleFavorite, clearFavorites, favoritesCount } = useLocalFavorites();
  const { favoriteVacations, loading } = useLocalFavoritesData(favorites);

  if (favoritesCount === 0) {
    return (
      <div className="container mx-auto px-4 py-8">
        <Button variant="outline" onClick={onBack} className="flex items-center gap-2 mb-6">
          <ArrowLeft className="h-4 w-4" />
          Terug naar zoeken
        </Button>
        
        <div className="text-center py-16">
          <Heart className="h-16 w-16 mx-auto text-gray-300 mb-4" />
          <h2 className="text-2xl font-bold text-gray-600 mb-2">Geen favorieten gevonden</h2>
          <p className="text-gray-500">
            Voeg vakanties toe aan je favorieten door op het hartje te klikken
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex items-center justify-between mb-6">
        <Button variant="outline" onClick={onBack} className="flex items-center gap-2">
          <ArrowLeft className="h-4 w-4" />
          Terug naar zoeken
        </Button>
        
        <Button
          variant="outline"
          onClick={clearFavorites}
          className="text-red-600 border-red-300 hover:bg-red-50"
        >
          Alle favorieten wissen
        </Button>
      </div>

      <div className="mb-6">
        <div className="flex items-center gap-2 mb-4">
          <Heart className="h-6 w-6 text-red-500 fill-current" />
          <h1 className="text-3xl font-bold text-gray-800">
            Jouw Favorieten ({favoritesCount})
          </h1>
        </div>
        <p className="text-gray-600">
          Vergelijk al je favoriete vakanties en vind de perfecte keuze
        </p>
      </div>

      {loading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {Array.from({ length: favoritesCount }).map((_, index) => (
            <VacationCardSkeleton key={index} />
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {favoriteVacations.map((vacation) => (
            <VacationCard
              key={vacation['product ID']}
              vacation={vacation}
              user={null}
              onFavoriteChange={() => {}}
            />
          ))}
        </div>
      )}

      {!loading && favoriteVacations.length === 0 && favoritesCount > 0 && (
        <div className="text-center py-8">
          <p className="text-gray-500">
            Er ging iets mis bij het laden van je favorieten. Probeer de pagina te vernieuwen.
          </p>
        </div>
      )}
    </div>
  );
};
